var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49522 16C8.02966 16 7.64961 15.6295 7.64961 15.1734V8.85511H1.51185C1.05579 8.85511 0.656738 8.46556 0.656738 8C0.656738 7.53444 1.05579 7.15439 1.51185 7.15439H7.64961V0.826603C7.64961 0.370546 8.02966 0 8.49522 0C8.96078 0 9.35032 0.370546 9.35032 0.826603V7.15439H15.4881C15.9441 7.15439 16.3432 7.53444 16.3432 8C16.3432 8.46556 15.9441 8.85511 15.4881 8.85511H9.35032V15.1734C9.35032 15.6295 8.96078 16 8.49522 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.9b70710653a241106a48c6e07699bb90.svg";
export { ForwardRef as ReactComponent };